export enum CoreFormEventsEnum {
  FORM_EVENT_UPDATE = 'FORM_EVENT_UPDATE',
  FORM_EVENT_SUBMIT = 'FORM_EVENT_SUBMIT',
  FORM_EVENT_RESET = 'FORM_EVENT_RESET',
  CONTROLLER_EVENT_UPDATE = 'CONTROLLER_EVENT_UPDATE',
  MENU_EVENT_UPDATE = 'MENU_EVENT_UPDATE'
}
